import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from '@atlassian/help-center-common-component/with-async';

export const ContactUsSection = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: 'async-contact-us' */ './contact-us-section')),
});
